export const PAY_NOW_LABEL = (paymentCardType: string) =>
  `Pay today with your ${paymentCardType} card and earn 10X miles `;
export const PAY_LATER_LABEL = (paymentCardType: string) =>
  `Pay at hotel with your ${paymentCardType} card and earn 2X miles`;
export const PAY_LATER_NOTES =
  "Please note that miles, travel credits and offers can’t be applied to the booking when paying at the hotel.";
export const SELECT_WHEN_TO_PAY = "Select when you'd like to pay";
export const SUBTITLE =
  "Enjoy the same cancellation policy and premium benefits with either option.";
export const READ_TERMS_AND_CONDITIONS = "Read terms and conditions";
export const CONTINUE = "Continue";
